export const CURRENT_SELECTION = 'map/CURRENT_SELECTION'
export const CURRENT_MAP_FILTER = 'map/CURRENT_MAP_FILTER'
export const MAP_BOUNDS = 'map/MAP_BOUNDS'
export const MAP_FOCUS_ON = 'map/MAP_FOCUS_ON'
export const MAP_POINTS = 'map/MAP_POINTS'
export const EASE_POINT = 'map/EASE_POINT'
export const HAS_TO_EASE_TO = 'map/HAS_TO_EASE_TO'
export const IS_LMT = 'map/IS_LMT'
